export type SourceStatus = 'connected' | 'not_connected' | 'reauth_required' | 'upstream_error' | 'setup_required';
export type ConnectKind = 'oauth_popup' | 'api_key_form' | 'unavailable';

export interface Source {
  id: string;
  label: string;
  status: SourceStatus;
  reason: string | null;
}

export interface SourcesResponse {
  sources: Source[];
}

export interface SourceMeta {
  id: string;
  label: string;
  letter: string;
  cssKey: string;
  connectKind: ConnectKind;
  pitch: string;
}

export const SOURCE_META: Record<string, SourceMeta> = {
  outlook:   { id: 'outlook',   label: 'Outlook',   letter: 'O', cssKey: 'outlook',   connectKind: 'oauth_popup',   pitch: 'Calendar meetings become time entries' },
  zoom:      { id: 'zoom',      label: 'Zoom',      letter: 'Z', cssKey: 'zoom',      connectKind: 'oauth_popup',   pitch: 'Meetings you attended become time entries' },
  freshdesk: { id: 'freshdesk', label: 'Freshdesk', letter: 'F', cssKey: 'freshdesk', connectKind: 'api_key_form',  pitch: 'Tickets you worked become time entries' },
} as const;
